import {
  formatError,
  healthCheck,
  login,
  login_user,
  revoke_token,
  runLogoutTimer,
  saveTokenInLocalStorage,
  signUp,
  user_logout,
} from "../../services/AuthService";
import { setAuthToken } from "../../jsx/helpers/api_helper";
import { errorMessage } from "../../jsx/pages/LIMSpages/CommonFunctions";

export const SIGNUP_CONFIRMED_ACTION = "[signup action] confirmed signup";
export const SIGNUP_FAILED_ACTION = "[signup action] failed signup";
export const LOGIN_CONFIRMED_ACTION = "[login action] confirmed login";
export const LOGIN_FAILED_ACTION = "[login action] failed login";
export const LOADING_TOGGLE_ACTION = "[Loading action] toggle loading";
export const LOGOUT_ACTION = "[Logout action] logout action";
export const NAVTOGGLE = "NAVTOGGLE";

export function signupAction(email, password, navigate) {
  return (dispatch) => {
    signUp(email, password)
      .then((response) => {
        saveTokenInLocalStorage(response.data);
        runLogoutTimer(
          dispatch,
          response.data.expiresIn * 1000
          //history,
        );
        dispatch(confirmedSignupAction(response.data));
        navigate("/dashboard");
        //history.push('/dashboard');
      })
      .catch((error) => {
        const errorMessage = formatError(error.response.data);
        dispatch(signupFailedAction(errorMessage));
      });
  };
}

export function Logout(navigate) {
  // const AuthUser = await localStorage.getItem("userDetails");
  const AuthUserString = localStorage.getItem("userDetails");
  const AuthUser = AuthUserString ? JSON.parse(AuthUserString) : null;

  const UserType = AuthUser?.UserType;
  const CustomerLoginURL =
    "/customer-login/" +
    AuthUser?.CustomerCompanyIDEncrypt +
    "/" +
    AuthUser?.CustomerCompanyName;

  if (AuthUser) {
    revoke_token(AuthUser?.RefreshToken);
    user_logout(AuthUser?.LoginIDEncrypt);
  }

  localStorage.removeItem("userDetails");
  //history.push('/login');
  //navigate("/login");

  if (UserType == 2) {
    window.location = CustomerLoginURL;
  } else {
    navigate("/login");
  }

  return {
    type: LOGOUT_ACTION,
  };
}

export function loginAction(email, password, navigate) {
  return (dispatch) => {
    login(email, password)
      .then((response) => {
        saveTokenInLocalStorage(response.data);
        // runLogoutTimer(
        //     dispatch,
        //     response.data.expiresIn * 1000,
        //     navigate,
        // );
        dispatch(loginConfirmedAction(response.data));
        navigate("/dashboard");
      })
      .catch((error) => {
        const errorMessage = formatError(error.response.data);
        dispatch(loginFailedAction(errorMessage));
      });
  };
}

export function loginFailedAction(data) {
  return {
    type: LOGIN_FAILED_ACTION,
    payload: data,
  };
}

export function loginConfirmedAction(data) {
  return {
    type: LOGIN_CONFIRMED_ACTION,
    payload: data,
  };
}

export function confirmedSignupAction(payload) {
  return {
    type: SIGNUP_CONFIRMED_ACTION,
    payload,
  };
}

export function signupFailedAction(message) {
  return {
    type: SIGNUP_FAILED_ACTION,
    payload: message,
  };
}

export function loadingToggleAction(status) {
  return {
    type: LOADING_TOGGLE_ACTION,
    payload: status,
  };
}
export const navtoggle = () => {
  return {
    type: "NAVTOGGLE",
  };
};

export function login_userAction(
  UserName,
  Password,
  navigate,
  setLoading,
  setShowLicenceExpiryModal,
  setLicenceInfo,
  companyID,
  companyName,
  UserType,
  deviceType,
) {
  return (dispatch) => {
    login_user(UserName, Password)
      .then((response) => {
        if (response.IsSuccess) {
          if (UserType == 1 && response?.UserType == 2) {
            errorMessage("Customer login link is invalid!");
            setLoading(false);
          } else {
            if (response?.UserType === 2) {
              if (response?.Permissions?.CustomerLogin == 1) {
                if (response?.IsDefaultPassword == true) {
                  window.location =
                    "/reset-password/" +
                    response?.GUID +
                    "/" +
                    companyID +
                    "/" +
                    companyName +
                    "/" +
                    response?.UserType +
                    "/" +
                    window.btoa(response?.LoginIDEncrypt);
                } else {
                  localStorage.setItem("userDetails", JSON.stringify(response));
                  dispatch(loginConfirmedAction(response));
                  setAuthToken(response?.Token); //set new token
                  navigate("/customer-inward");
                }
              } else {
                errorMessage("Customer login is not allowed!");
                setLoading(false);
              }
            } else {
              if (UserType === 2) {
                errorMessage("Customer login username or password invalid!");
                setLoading(false);
              } else {
                localStorage.setItem("userDetails", JSON.stringify(response));
                dispatch(loginConfirmedAction(response));
                setAuthToken(response?.Token); //set new token
                deviceType == "desktop"
                  ? navigate("/dashboard")
                  : navigate("/testing-result");
              }
            }
          }
        } else {
          if (response?.OnExpiry == 1) {
            setLicenceInfo({
              LicenceExpiryDate: response?.LicenceExpiryDate,
              LicenceHelpNumber: response?.LicenceHelpNumber,
              LicenceHelpEmail: response?.LicenceHelpEmail,
            });
            setShowLicenceExpiryModal(true);
          } else {
            // swal("Oops", response.Message, "error");
            errorMessage(response?.Message);
          }
          setLoading(false);
        }
      })
      .catch((error) => {
        const errorMessage = formatError(error.response.data);
        dispatch(loginFailedAction(errorMessage));
      });
  };
}

export function HealthCheck(navigate) {
  return (dispatch) => {
    const AuthUserString = localStorage.getItem("userDetails");
    const AuthUser = AuthUserString ? JSON.parse(AuthUserString) : null;

    if (AuthUser) {
      healthCheck(AuthUser?.RefreshToken)
        .then((response) => {
          if (response.IsSuccess == false) {
            dispatch(Logout(navigate));
          }
        })
        .catch((error) => {
          const errorMessage = formatError(error.response.data);
          console.log("Health Check:", errorMessage);
        });
    }
  };
}
